var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserCircleGear = function SvgIconUserCircleGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.555 5.348A8 8 0 0 1 12 4a1 1 0 1 0 0-2 10 10 0 1 0 9.926 8.796 1 1 0 1 0-1.984.252q.06.471.058.947V12a8 8 0 0 1-1.817 5.076 7.75 7.75 0 0 0-2.933-2.362 4.75 4.75 0 1 0-6.5 0 7.75 7.75 0 0 0-2.933 2.363A8 8 0 0 1 7.555 5.348m-.272 13.113a8 8 0 0 0 9.434 0A5.75 5.75 0 0 0 12.051 16h-.101a5.75 5.75 0 0 0-4.667 2.461M18.75 2.375a1 1 0 0 1 1 1v.497l.471-.154a1 1 0 1 1 .62 1.901l-.472.155.296.406a1 1 0 0 1-1.617 1.177l-.298-.409-.298.41a1 1 0 0 1-1.617-1.178l.296-.406-.473-.155a1 1 0 0 1 .621-1.9l.471.153v-.497a1 1 0 0 1 1-1m-9.5 8.875A2.75 2.75 0 1 1 12.045 14h-.09a2.75 2.75 0 0 1-2.705-2.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconUserCircleGear;